import React from "react";

import styles from "./styles/Details.module.scss";
import { ROUTES } from "./contants";
import EditProfile from "./EditProfile";
import ChangePassword from "./ChangePassword";
import FaqManagement from "./FaqManagement";
import { IoIosArrowBack } from "react-icons/io";

export default function Details({ isMobile = false, route = "", setRoute }) {
  const handleBackButtonClck = () => {
    setRoute("");
  };

  return (
    <div className={styles.Details}>
      {isMobile ? (
        <button
          type="button"
          className={styles.backButton}
          onClick={handleBackButtonClck}
          aria-label="Back"
        >
          <IoIosArrowBack />
        </button>
      ) : null}
      {route === ROUTES.EDIT_PROFILE ? <EditProfile /> : null}
      {route === ROUTES.CHANGE_PASSWORD ? <ChangePassword /> : null}
      {route === ROUTES.FAQ_MANAGEMENT ? <FaqManagement /> : null}
    </div>
  );
}
